import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoundDoor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-round-door"><path d="M12.3975 3.114C12.1543 2.962 11.8457 2.962 11.6025 3.114L3.3525 8.27025C3.13321 8.40731 3 8.64766 3 8.90625V20.25C3 20.6642 3.33579 21 3.75 21H8.75C9.16421 21 9.5 20.6642 9.5 20.25V16.75C9.5 15.3693 10.6193 14.25 12 14.25C13.3807 14.25 14.5 15.3693 14.5 16.75V20.25C14.5 20.6642 14.8358 21 15.25 21H20.25C20.6642 21 21 20.6642 21 20.25V8.90625C21 8.64766 20.8668 8.40731 20.6475 8.27025L12.3975 3.114Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeRoundDoor;
